import { useState, useEffect } from 'react';

import SkillsSlider from '../SkillsSlider/SkillsSlider';
import './Skills.css';

function Skills() {
  const [skillsFade, setSkillsFade] = useState({
    fade: 'fade-out',
    position: 'bottom',
  });

  useEffect(() => {
    const timeout = setInterval(() => {
      if (skillsFade.fade === 'fade-out') {
        setSkillsFade({
          fade: 'fade-in',
          position: 'center',
        });
      }
    }, 200);
    return () => clearInterval(timeout);
  }, [skillsFade]);

  const skills = [
    {
      name: 'HTML',
      icon: 'fab fa-html5',
    },
    {
      name: 'CSS',
      icon: 'fab fa-css3-alt',
    },
    {
      name: 'Javascript',
      icon: 'fab fa-js',
    },
    {
      name: 'React',
      icon: 'fab fa-react',
    },
    {
      name: 'Node.js',
      icon: 'fab fa-node',
    },
    {
      name: 'GitHub',
      icon: 'fab fa-github',
    },
    {
      name: 'Express',
    },
    {
      name: 'Laravel',
      icon: 'fab fa-laravel',
    },
    {
      name: 'Bootstrap',
      icon: 'fab fa-bootstrap',
    },
  ];

  return (
    <div
      className={`skills-container ${skillsFade.fade} ${skillsFade.position}`}
    >
      <SkillsSlider data={skills} />
    </div>
  );
}

export default Skills;
